export default __webpack_public_path__ + "locales/az/Article.json?hash=c1edab105833133d53706501cf4c87ee";